import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import LocateControl from './ReactLeafletLocate.jsx';
import './Map.css';

import * as L from 'leaflet';
import { Map, TileLayer, Circle, ZoomControl, Marker, GeoJSON } from 'react-leaflet';

//export default class TheMap extends React.Component {
const TheMap = ( { zoom, center, bounds, gravestones, userLocation, icon, hillshadeOn, perimeter, selectedGravestone, dispatch, changeCenterAndZoom, changeBounds, selectGravestone }) => {
  const theRef = useRef(null);

  const onMapMoved = () => {
    const theMap = theRef.current.leafletElement;
    const newZoom = theMap.getZoom();
    const newCenterLatLng = theMap.getCenter();
    const newCenter = [newCenterLatLng.lat, newCenterLatLng.lng];

    const oldCenterLatLng = L.latLng(center);

    const newCenterProjected = theMap.latLngToLayerPoint(newCenterLatLng);
    const oldCenterProjected = theMap.latLngToLayerPoint(oldCenterLatLng);

    if (newZoom !== zoom || newCenterProjected.x !== oldCenterProjected.x || newCenterProjected.y !== oldCenterProjected.y) {
      dispatch(changeCenterAndZoom(newCenter, newZoom));
    }

    const boundsObj = theMap.getBounds();
    const newBounds = [
      [boundsObj._northEast.lat, boundsObj._northEast.lng],
      [boundsObj._southWest.lat, boundsObj._southWest.lng],
    ];
    if (bounds[0][0] !== newBounds[0][0] || bounds[0][1] !== newBounds[0][1]
      || bounds[1][0] !== newBounds[1][0] || bounds[1][1] !== newBounds[1][1]) {
      dispatch(changeBounds(newBounds));
    }
  };

  // call useEffect to initialize preliminary view on mount
  useEffect(() => {
    onMapMoved();
  }, []);

  const onMarkerClicked = (e) =>  {
    let { id } = e.target.options;
    if (parseInt(selectedGravestone, 10) === parseInt(id, 10)) {
      id = null;
    }
    dispatch(selectGravestone(id));
  };

  return (
    <React.Fragment>
      <Map
        className='the_map'
        id='the_map'
        boundsOptions={{ maxZoom: 22 }}
        center={center}
        zoom={zoom}
        maxZoom={24}
        minZoom={16}
        maxBounds={[[37.532394232849335, -77.39232258405536], [37.54, -77.38342452328654]]}
        zoomControl={false}
        ref={theRef}
        onMoveEnd={onMapMoved}
      >


        {(hillshadeOn) ? (
          <TileLayer 
            url='//s3.amazonaws.com/dsl-general/eastendHillshade/{z}/{x}/{y}.png' 
            maxNativeZoom={ 22 }
            maxZoom={ 25 }
            detectRetina={ true }
          />
        ) : (
            <React.Fragment>
              <TileLayer
                url='//gis.henrico.us/arcgis/rest/services/Henrico_Hybrid_Map/MapServer/tile/{z}/{y}/{x}'
                maxNativeZoom={ 19 }
                maxZoom={ 25 }
                detectRetina={ true }
              />

              <TileLayer url='https://cartodb-basemaps-{s}.global.ssl.fastly.net/rastertiles/voyager_only_labels/{z}/{x}/{y}.png' />

              <TileLayer 
                url='//s3.amazonaws.com/dsl-general/eastend2020/{z}/{x}/{y}.png' 
                maxNativeZoom={ 22 }
                maxZoom={ 25 }
                detectRetina={ true }
              />

              <GeoJSON
                data={perimeter}
                color='#262626'
                weight={0.5}
                fillColor='#262626'
                fillOpacity={0.5}
                className='perimeter'
              />
            </React.Fragment>
        )}



        {gravestones.map(g => (
          <Circle
            center={g.center}
            radius={g.radius}
            fillColor={g.fill}
            fillOpacity={(!hillshadeOn) ? g.fillOpacity : g.fillOpacity / 2}
            color='black'
            weight={g.weight}
            opacity={g.opacity}
            onClick={onMarkerClicked}
            id={g.id}
            key={g.key}
          />
        ))}

        {(userLocation) && (
          <Marker
            position={userLocation}
            icon={icon}
            className="userLocation"
          />
        )}

        <ZoomControl
          position='bottomright'
        />

        <LocateControl 
          options={{
            position: 'bottomright' 
          }}
        />


        
      </Map>

    </React.Fragment>
  );
};

export default TheMap;

TheMap.propTypes = {
  zoom: PropTypes.number.isRequired,
  center: PropTypes.arrayOf(PropTypes.number).isRequired,
  bounds: PropTypes.arrayOf(PropTypes.array).isRequired,
  gravestones: PropTypes.arrayOf(PropTypes.object).isRequired,
  userLocation: PropTypes.arrayOf(PropTypes.number),
  selectedGravestone: PropTypes.number,
  selectGravestone: PropTypes.func.isRequired,
  changeCenterAndZoom: PropTypes.func.isRequired,
  changeBounds: PropTypes.func.isRequired,
  perimeter: PropTypes.object,
  icon: PropTypes.object,
};

TheMap.defaultProps = {
  selectedHeadstone: null,
  icon: L.icon({
    iconUrl: './userLocation.svg',
    iconSize: [50, 50],
    iconAnchor: [25, 25],
  }),
};



// WEBPACK FOOTER //
// ./src/components/Map.jsx